import CartButton from '@/components/Header/CartButton';
import NotificationButton from '@/components/Header/NotificationButton';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface MobileMenuUtilityNavigationProps {
  showCartButton: boolean;
  close: () => void;
  cartItemCount: number;
}

const MobileMenuUtilityNavigation = ({
  showCartButton,
  close,
  cartItemCount,
}: MobileMenuUtilityNavigationProps) => {
  return (
    <>
      <div className="flex flex-1 justify-end gap-3">
        <NotificationButton onClick={close} />
        {showCartButton && <CartButton onClick={close} count={cartItemCount} />}
      </div>
      <div className="ml-4">
        <button type="button" className="-m-2.5 rounded-md p-2.5 text-gray-700" onClick={close}>
          <span className="sr-only">Close menu</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
    </>
  );
};

export default MobileMenuUtilityNavigation;
